import React from 'react';
import {useTranslation} from 'react-i18next';
import {UPLOAD_PHOTO_STATES} from '../constants';
import {usePhotoBoxStore} from '../store';
import {Button} from '@chekinapp/ui';

type ButtonsProps = {
  state: UPLOAD_PHOTO_STATES;
  onChange?: () => void;
  onCapture?: () => void;
  onFinishUploadPhoto?: () => void;
  onConfirmCrop?: () => void;
  disabled?: boolean;
};
const Buttons = ({
  state,
  onChange,
  onCapture,
  onFinishUploadPhoto,
  onConfirmCrop,
  disabled,
}: ButtonsProps) => {
  const uploadedImage = usePhotoBoxStore(state => state.uploadedImage);
  const {t} = useTranslation();

  const getButtons = React.useCallback(() => {
    switch (state) {
      case UPLOAD_PHOTO_STATES.take:
        return (
          <Button variant="outline" onClick={onCapture} disabled={disabled} size="md">
            {t('take_photo')}
          </Button>
        );
      case UPLOAD_PHOTO_STATES.scan:
        return (
          <Button onClick={onCapture} disabled={disabled} size="md">
            {t('scan_document')}
          </Button>
        );
      case UPLOAD_PHOTO_STATES.crop:
        return (
          <Button onClick={onConfirmCrop} disabled={disabled} size="md">
            {t('confirm')}
          </Button>
        );
      case UPLOAD_PHOTO_STATES.confirmUpload:
        return (
          <>
            <Button
              onClick={onFinishUploadPhoto}
              disabled={disabled || !uploadedImage}
              size="md"
            >
              {t('start_verification')}
            </Button>
            <Button
              variant="secondary"
              disabled={disabled || !uploadedImage}
              onClick={onChange}
              size="md"
            >
              {t('change_photo')}
            </Button>
          </>
        );
      case UPLOAD_PHOTO_STATES.upload:
        return null;
    }
  }, [
    state,
    t,
    onCapture,
    onFinishUploadPhoto,
    onConfirmCrop,
    disabled,
    onChange,
    uploadedImage,
  ]);

  return (
    <div className="mt-[43px] photo-box__btns  flex w-full flex-col items-center justify-center gap-5 kiosko:mt-[114px]">
      {getButtons()}
    </div>
  );
};

export {Buttons};
